/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './line_item';
import '../../../connect/v2/common/money';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "CurrentUser": {
                    "fields": {
                      "email": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "userId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Order": {
                    "fields": {
                      "number": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": "squareup.solidshop.v2.resources.Order.State",
                        "id": 2,
                        "rule": "optional"
                      },
                      "currentUser": {
                        "type": "squareup.solidshop.v2.resources.CurrentUser",
                        "id": 3,
                        "rule": "optional"
                      },
                      "lineItems": {
                        "type": "squareup.solidshop.v2.resources.LineItem",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "subtotal": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "total": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "shipmentState": {
                        "type": "squareup.solidshop.v2.resources.Order.ShipmentState",
                        "id": 7,
                        "rule": "optional"
                      },
                      "shipmentStatus": {
                        "type": "squareup.solidshop.v2.resources.Order.ShipmentStatus",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "State": {
                        "values": {
                          "COMPLETE": 1,
                          "CANCELED": 2,
                          "AWAITING_RETURN": 3,
                          "RETURNED": 4,
                          "CART": 5,
                          "CONFIRM": 6,
                          "EXPIRED": 7,
                          "SHIPPED": 8
                        }
                      },
                      "ShipmentState": {
                        "values": {
                          "CANCELED_SHIPMENT": 1,
                          "PENDING_SHIPMENT": 2,
                          "PARTIAL_SHIPMENT": 3,
                          "READY_SHIPMENT": 4,
                          "SHIPPED_SHIPMENT": 5,
                          "DELIVERED_SHIPMENT": 6
                        }
                      },
                      "ShipmentStatus": {
                        "values": {
                          "UNKNOWN_STATUS": 0,
                          "SHIPPED_STATUS": 1,
                          "PARTIALLY_DELIVERED_STATUS": 2,
                          "DELIVERED_STATUS": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.CurrentUser && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.Order && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.Order?.nested?.State && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.Order?.nested?.ShipmentState && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.Order?.nested?.ShipmentStatus) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE CurrentUser @ squareup/solidshop/v2/resources/order.proto at 11:1
 */
export const CurrentUser = $root.lookupType('squareup.solidshop.v2.resources.CurrentUser');
fixType(CurrentUser);
Builder.createAndAttachToType(CurrentUser);
/**
 * SOURCE Order @ squareup/solidshop/v2/resources/order.proto at 22:1
 */
export const Order = $root.lookupType('squareup.solidshop.v2.resources.Order');
fixType(Order);
Builder.createAndAttachToType(Order);
/**
 * these are all the available calculated states of any order
 * https://github.com/squareup/solidshop/blob/main/app/adapters/solidshop/order_adapter.rb#L583-L603
 *
 * SOURCE State @ squareup/solidshop/v2/resources/order.proto at 27:3
 */
Order.State = $root.lookupEnum('squareup.solidshop.v2.resources.Order.State').values;
/**
 * SOURCE ShipmentState @ squareup/solidshop/v2/resources/order.proto at 53:3
 */
Order.ShipmentState = $root.lookupEnum('squareup.solidshop.v2.resources.Order.ShipmentState').values;
/**
 * SOURCE ShipmentStatus @ squareup/solidshop/v2/resources/order.proto at 73:3
 */
Order.ShipmentStatus = $root.lookupEnum('squareup.solidshop.v2.resources.Order.ShipmentStatus').values;
